import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { FlexCard, usePageSize } from './../';
import styled from 'styled-components';

// **********************************************************
// Constants
// **********************************************************

export const defaultPageSize = 10;
export const defaultPageSizes = [10, 25, 50, 100, 250, 500, 1000, 2000, 4000];
export const getDefaultPageSizeOptions = () =>
  defaultPageSizes.map((size, index) => ({
    key: index,
    value: size,
    text: size,
  }));

export const PageSizeSelect = ({
  pageSize,
  title,
  totalItems,
  onPageSizeChanged,
}) => {
  const { options, show, currentPageSize, handlePageSizeChange } = usePageSize({
    pageSize,
    totalItems,
    onPageSizeChanged,
    defaultPageSize,
    defaultPageSizeOptions: getDefaultPageSizeOptions(),
  });

  if (!show) return null;

  return (
    <StyledWrapper verticalAlignment="center">
      <label data-testid="page-size-label">{`${title} Per Page`}</label>
      <Dropdown
        data-testid="page-size-dropdown"
        options={options}
        inline
        value={currentPageSize}
        onChange={(e, data) =>
          handlePageSizeChange(e, data, { match: data.value === totalItems })
        }
      />
    </StyledWrapper>
  );
};

export const StyledWrapper = styled(FlexCard)`
  margin-right: 10px;
  > label {
    margin-top: 7px;
    margin-right: 10px;
  }
`;
